import templateUrl from './edit-onboarding-policy-application-status-modal.html'

export const EditOnboardingPolicyApplicationStatusModalComponent = {
    controller: EditOnboardingPolicyApplicationStatusModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
}

function EditOnboardingPolicyApplicationStatusModalController(onboardingPolicyService, utilityService) {
    'ngInject'
    const vm = this;
    vm.$onInit = onInit;
    vm.onChangeStatusType = onChangeStatusType;
    vm.filterResultStatuses = filterResultStatuses;
    vm.onMoveItem = onMoveItem;
    vm.onSave = onSave;

    function onInit() {
        vm.applicationStatus = vm.resolve.applicationStatus;
        vm.index = vm.resolve.index;
        vm.onboardingPolicy = vm.resolve.onboardingPolicy;
        vm.isNew = vm.resolve.isNew;
        vm.sortIndexMode = 'bottom';

        if (vm.isNew) {
            // Generate a new array consisting of the old array concatenated with the new value.
            // Then insert the item into its resolved sort index.
            vm.resultStatuses = vm.onboardingPolicy.ApplicationStatuses.concat([vm.applicationStatus]);
            utilityService.moveItem(vm.resultStatuses, vm.applicationStatus, vm.applicationStatus.SortIndex);
        } else {
            vm.resultStatuses = vm.onboardingPolicy.ApplicationStatuses.map(function (status, i) {
                return i === vm.index ? vm.applicationStatus : status;
            });
        }
        vm.statusTypes = vm.resolve.statusTypes;
    }

    function onMoveItem(items, selectedItem, index) {
        utilityService.moveItem(items, selectedItem, index);
        selectedItem.SortIndex = index;
    }

    function onSave() {
        validateChange();
        if (vm.editForm && vm.editForm.$invalid) {
            alert("Cannot save: validation errors in form");
        }

        if (vm.isNew && !confirm("The application status will be added to this list. This cannot be undone. Continue?")) {
            return;
        }

        const request = {
            Name: vm.applicationStatus.Name,
            StatusType: vm.applicationStatus.StatusType,
            SortIndex: vm.sortIndexMode === 'specific' ? vm.applicationStatus.SortIndex : null,
            Inactive: vm.applicationStatus.Inactive
        };

        const saved = vm.isNew ? onboardingPolicyService.addApplicationStatus(
            vm.onboardingPolicy.OnboardingPolicyID, request)
            : onboardingPolicyService.updateApplicationStatus(vm.onboardingPolicy.OnboardingPolicyID,
                vm.applicationStatus.OnboardingApplicationStatusID, request);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Save failed"));

        return saved.then(function (id) {
            if (vm.isNew) {
                request.OnboardingApplicationStatusID = id;
            }
            vm.close({ $value: request });
        })
    }

    function onChangeStatusType() {
        validateChange();
    }

    function validateChange() {
        if (!vm.editForm) {
            return;
        }

        const atLeastOneInitialStatus = vm.resultStatuses.reduce(function (any, status) {
            return any || status.StatusType === "Initial";
        }, false);
        vm.editForm.$setValidity("atLeastOneInitialStatus", atLeastOneInitialStatus);
    }

    function filterResultStatuses(status) {
        return status !== vm.applicationStatus || vm.sortIndexMode === 'specific';
    }
}
